import {
  GET_OPSGENIE_TEAMS_SUCCESS, GET_OPSGENIE_TEAMS_FAIL, GET_OPSGENIE_TEAMS,GET_REFRESH_OPSGENIE, GET_REFRESH_OPSGENIE_SUCCESS, GET_REFRESH_OPSGENIE_FAIL
} from "./actionTypes";

const INIT_STATE = {
  opsgenie_teams: [],
  opsgenie_refresh: []
};

const OpsGenieTeams = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_OPSGENIE_TEAMS:
      return {
        ...state,
        error: action.payload,
      }

    case GET_OPSGENIE_TEAMS_SUCCESS:
      return {
        ...state,
        opsgenie_teams: Object.assign(state.opsgenie_teams, action.payload),
      }

    case GET_OPSGENIE_TEAMS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_REFRESH_OPSGENIE:
      return {
        ...state,
        error: action.payload,
      }

    case GET_REFRESH_OPSGENIE_SUCCESS:
      return {
        ...state,
        opsgenie_refresh: action.payload
      }

    case GET_REFRESH_OPSGENIE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}


export default OpsGenieTeams;